import { NavLink, useLocation } from 'react-router-dom';

import { ListItemButton, ListItemText } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { navLeafAnchorId } from './navTourAnchors.js';
import { leafSegmentPseudo, type LineMode, tickPseudo } from './treeLines.js';
import type { NavLeaf } from './types.js';

export function NavLeafItem({
  item,
  indented = false,
  lineMode,
  onClose,
}: {
  item: NavLeaf;
  indented?: boolean;
  lineMode?: LineMode;
  onClose?: () => void;
}) {
  const { pathname } = useLocation();
  const isActive = pathname === item.href || pathname.startsWith(item.href + '/');

  return (
    <ListItemButton
      component={NavLink}
      id={navLeafAnchorId(item.href)}
      selected={isActive}
      sx={(theme) => ({
        position: 'relative',
        borderRadius: 1,
        minHeight: 36,
        py: 0.5,
        my: 0.25,
        pl: indented ? 1.25 : 2,
        pr: 2,
        color: alpha(theme.palette.common.white, 0.7),
        transition: 'none',
        ...(indented && { '&::before': tickPseudo() }),
        ...(lineMode && { '&::after': leafSegmentPseudo(lineMode) }),
        '&:hover': {
          bgcolor: alpha(theme.palette.common.white, 0.08),
          color: theme.palette.common.white,
        },
        '&.Mui-selected': {
          bgcolor: alpha(theme.palette.secondary.main, 0.13),
          color: theme.palette.secondary.main,
          '&:hover': { bgcolor: alpha(theme.palette.secondary.main, 0.2) },
        },
      })}
      to={item.href}
      onClick={onClose}
    >
      <ListItemText primary={item.label} slotProps={{ primary: { variant: 'body2' } }} />
    </ListItemButton>
  );
}
